import { render } from "./cp_major_select.vue?vue&type=template&id=b2769eee&scoped=true"
import script from "./cp_major_select.vue?vue&type=script&lang=js"
export * from "./cp_major_select.vue?vue&type=script&lang=js"

import "./cp_major_select.vue?vue&type=style&index=0&id=b2769eee&scoped=scoped&lang=css"

import exportComponent from "E:\\WorkCode\\HZY2026\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2769eee"]])

export default __exports__